import { render, staticRenderFns } from "./StockKLine.vue?vue&type=template&id=982fc3aa&scoped=true"
import script from "./StockKLine.vue?vue&type=script&lang=js"
export * from "./StockKLine.vue?vue&type=script&lang=js"
import style0 from "./StockKLine.vue?vue&type=style&index=0&id=982fc3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982fc3aa",
  null
  
)

export default component.exports